import React from 'react';
import { Trans } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import { Text } from '@actual-app/components/text';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';

import type { TransferMatchProfile } from '#banksync/transfer-profiles';

type Props = {
  profile: TransferMatchProfile;
  onEdit: () => void;
  onDelete: () => void;
  onToggleEnabled: () => void;
};

export function TransferMatchProfileRow({
  profile,
  onEdit,
  onDelete,
  onToggleEnabled,
}: Props) {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        padding: 8,
        borderBottom: '1px solid ' + theme.tableBorder,
        flexShrink: 0,
        opacity: profile.enabled ? 1 : 0.5,
      }}
    >
      {/* name column | let it truncate, no flexShrink */}
      <View style={{ flex: 1, minWidth: 0 }}>
        <Text style={{ fontSize: 13, fontWeight: 500 }}>
          {profile.name || <Trans>(unnamed profile)</Trans>}
        </Text>
        <Text style={{ fontSize: 12, color: theme.pageTextSubdued }}>
          <Trans count={profile.payeeIds.length}>
            {{ count: profile.payeeIds.length }} payees
          </Trans>
          {' | '}
          <Trans count={profile.windowDays}>
            ± {{ count: profile.windowDays }} days
          </Trans>
        </Text>
      </View>
      <Button onPress={onToggleEnabled}>
        {profile.enabled ? <Trans>Disable</Trans> : <Trans>Enable</Trans>}
      </Button>
      <Button onPress={onEdit}>
        <Trans>Edit</Trans>
      </Button>
      <Button onPress={onDelete}>
        <Trans>Delete</Trans>
      </Button>
    </View>
  );
}
